// src/services/iplSchedule.js
// IPL 2026 full league stage schedule (70 matches, Mar 28 – May 24).
//
// Fantasy "weeks" are game-rounds, not calendar weeks.
// Week N starts when the FIRST team plays their N-th IPL match of the season.
// A match belongs to week N if homeGame === N or awayGame === N.
// All times are IST (UTC+5:30), stored as UTC ms.

// IST offset helper
const ist = (dateStr, hour = 19, min = 30) => {
  // dateStr: "YYYY-MM-DD", default 7:30 PM IST evening slot
  const [y, m, d] = dateStr.split("-").map(Number);
  // IST = UTC+5:30, so UTC = IST - 5:30
  return Date.UTC(y, m - 1, d, hour - 5, min - 30);
};

// IPL 2026 all 70 league stage fixtures.
// homeGame / awayGame = which game number this is for each team this season.
export const IPL_2026_MATCHES = [
  // Round 1 (each team's 1st match)
  { match: 1,  date: "2026-03-28", home: "RCB",  away: "SRH",  time: ist("2026-03-28", 19, 30), homeGame: 1,  awayGame: 1  },
  { match: 2,  date: "2026-03-29", home: "MI",   away: "KKR",  time: ist("2026-03-29", 19, 30), homeGame: 1,  awayGame: 1  },
  { match: 3,  date: "2026-03-30", home: "RR",   away: "CSK",  time: ist("2026-03-30", 19, 30), homeGame: 1,  awayGame: 1  },
  { match: 4,  date: "2026-03-31", home: "PBKS", away: "GT",   time: ist("2026-03-31", 19, 30), homeGame: 1,  awayGame: 1  },
  { match: 5,  date: "2026-04-01", home: "LSG",  away: "DC",   time: ist("2026-04-01", 19, 30), homeGame: 1,  awayGame: 1  },
  // Round 2
  { match: 6,  date: "2026-04-02", home: "KKR",  away: "SRH",  time: ist("2026-04-02", 19, 30), homeGame: 2,  awayGame: 2  },
  { match: 7,  date: "2026-04-03", home: "CSK",  away: "PBKS", time: ist("2026-04-03", 19, 30), homeGame: 2,  awayGame: 2  },
  { match: 8,  date: "2026-04-04", home: "DC",   away: "MI",   time: ist("2026-04-04", 15, 30), homeGame: 2,  awayGame: 2  },
  { match: 9,  date: "2026-04-04", home: "GT",   away: "RR",   time: ist("2026-04-04", 19, 30), homeGame: 2,  awayGame: 2  },
  { match: 10, date: "2026-04-05", home: "SRH",  away: "LSG",  time: ist("2026-04-05", 15, 30), homeGame: 3,  awayGame: 2  },
  // Round 3
  { match: 11, date: "2026-04-05", home: "RCB",  away: "CSK",  time: ist("2026-04-05", 19, 30), homeGame: 2,  awayGame: 3  },
  { match: 12, date: "2026-04-06", home: "KKR",  away: "PBKS", time: ist("2026-04-06", 19, 30), homeGame: 3,  awayGame: 3  },
  { match: 13, date: "2026-04-07", home: "RR",   away: "MI",   time: ist("2026-04-07", 19, 30), homeGame: 3,  awayGame: 3  },
  { match: 14, date: "2026-04-08", home: "DC",   away: "GT",   time: ist("2026-04-08", 19, 30), homeGame: 3,  awayGame: 3  },
  { match: 15, date: "2026-04-09", home: "KKR",  away: "LSG",  time: ist("2026-04-09", 19, 30), homeGame: 4,  awayGame: 3  },
  // Round 4
  { match: 16, date: "2026-04-10", home: "RR",   away: "RCB",  time: ist("2026-04-10", 19, 30), homeGame: 4,  awayGame: 3  },
  { match: 17, date: "2026-04-11", home: "PBKS", away: "SRH",  time: ist("2026-04-11", 15, 30), homeGame: 4,  awayGame: 4  },
  { match: 18, date: "2026-04-11", home: "CSK",  away: "DC",   time: ist("2026-04-11", 19, 30), homeGame: 4,  awayGame: 4  },
  { match: 19, date: "2026-04-12", home: "LSG",  away: "GT",   time: ist("2026-04-12", 15, 30), homeGame: 4,  awayGame: 4  },
  { match: 20, date: "2026-04-12", home: "MI",   away: "RCB",  time: ist("2026-04-12", 19, 30), homeGame: 4,  awayGame: 4  },
  // Round 5
  { match: 21, date: "2026-04-13", home: "SRH",  away: "RR",   time: ist("2026-04-13", 19, 30), homeGame: 5,  awayGame: 5  },
  { match: 22, date: "2026-04-14", home: "CSK",  away: "KKR",  time: ist("2026-04-14", 19, 30), homeGame: 5,  awayGame: 5  },
  { match: 23, date: "2026-04-15", home: "RCB",  away: "LSG",  time: ist("2026-04-15", 19, 30), homeGame: 5,  awayGame: 5  },
  { match: 24, date: "2026-04-16", home: "MI",   away: "PBKS", time: ist("2026-04-16", 19, 30), homeGame: 5,  awayGame: 5  },
  { match: 25, date: "2026-04-17", home: "GT",   away: "KKR",  time: ist("2026-04-17", 19, 30), homeGame: 5,  awayGame: 6  },
  // Round 6
  { match: 26, date: "2026-04-18", home: "RCB",  away: "DC",   time: ist("2026-04-18", 15, 30), homeGame: 6,  awayGame: 5  },
  { match: 27, date: "2026-04-18", home: "SRH",  away: "CSK",  time: ist("2026-04-18", 19, 30), homeGame: 6,  awayGame: 6  },
  { match: 28, date: "2026-04-19", home: "KKR",  away: "RR",   time: ist("2026-04-19", 15, 30), homeGame: 7,  awayGame: 6  },
  { match: 29, date: "2026-04-19", home: "PBKS", away: "LSG",  time: ist("2026-04-19", 19, 30), homeGame: 6,  awayGame: 6  },
  { match: 30, date: "2026-04-20", home: "GT",   away: "MI",   time: ist("2026-04-20", 19, 30), homeGame: 6,  awayGame: 6  },
  { match: 31, date: "2026-04-21", home: "SRH",  away: "DC",   time: ist("2026-04-21", 19, 30), homeGame: 7,  awayGame: 6  },
  { match: 32, date: "2026-04-22", home: "LSG",  away: "RR",   time: ist("2026-04-22", 19, 30), homeGame: 7,  awayGame: 7  },
  // Round 7
  { match: 33, date: "2026-04-23", home: "MI",   away: "CSK",  time: ist("2026-04-23", 19, 30), homeGame: 7,  awayGame: 7  },
  { match: 34, date: "2026-04-24", home: "RCB",  away: "GT",   time: ist("2026-04-24", 19, 30), homeGame: 7,  awayGame: 7  },
  { match: 35, date: "2026-04-25", home: "DC",   away: "PBKS", time: ist("2026-04-25", 15, 30), homeGame: 7,  awayGame: 7  },
  { match: 36, date: "2026-04-25", home: "RR",   away: "SRH",  time: ist("2026-04-25", 19, 30), homeGame: 8,  awayGame: 8  },
  // Round 8
  { match: 37, date: "2026-04-26", home: "GT",   away: "CSK",  time: ist("2026-04-26", 15, 30), homeGame: 8,  awayGame: 8  },
  { match: 38, date: "2026-04-26", home: "LSG",  away: "KKR",  time: ist("2026-04-26", 19, 30), homeGame: 8,  awayGame: 8  },
  { match: 39, date: "2026-04-27", home: "DC",   away: "RCB",  time: ist("2026-04-27", 19, 30), homeGame: 8,  awayGame: 8  },
  { match: 40, date: "2026-04-28", home: "PBKS", away: "RR",   time: ist("2026-04-28", 19, 30), homeGame: 8,  awayGame: 9  },
  { match: 41, date: "2026-04-29", home: "MI",   away: "SRH",  time: ist("2026-04-29", 19, 30), homeGame: 8,  awayGame: 9  },
  { match: 42, date: "2026-04-30", home: "GT",   away: "RCB",  time: ist("2026-04-30", 19, 30), homeGame: 9,  awayGame: 9  },
  // Round 9
  { match: 43, date: "2026-05-01", home: "RR",   away: "DC",   time: ist("2026-05-01", 19, 30), homeGame: 10, awayGame: 9  },
  { match: 44, date: "2026-05-02", home: "CSK",  away: "MI",   time: ist("2026-05-02", 19, 30), homeGame: 9,  awayGame: 9  },
  { match: 45, date: "2026-05-03", home: "SRH",  away: "KKR",  time: ist("2026-05-03", 15, 30), homeGame: 10, awayGame: 9  },
  { match: 46, date: "2026-05-03", home: "GT",   away: "PBKS", time: ist("2026-05-03", 19, 30), homeGame: 10, awayGame: 9  },
  { match: 47, date: "2026-05-04", home: "MI",   away: "LSG",  time: ist("2026-05-04", 19, 30), homeGame: 10, awayGame: 9  },
  // Round 10
  { match: 48, date: "2026-05-05", home: "DC",   away: "CSK",  time: ist("2026-05-05", 19, 30), homeGame: 10, awayGame: 10 },
  { match: 49, date: "2026-05-06", home: "SRH",  away: "PBKS", time: ist("2026-05-06", 19, 30), homeGame: 11, awayGame: 10 },
  { match: 50, date: "2026-05-07", home: "LSG",  away: "RCB",  time: ist("2026-05-07", 19, 30), homeGame: 10, awayGame: 10 },
  { match: 51, date: "2026-05-08", home: "DC",   away: "KKR",  time: ist("2026-05-08", 19, 30), homeGame: 11, awayGame: 10 },
  { match: 52, date: "2026-05-09", home: "RR",   away: "GT",   time: ist("2026-05-09", 19, 30), homeGame: 11, awayGame: 11 },
  // Round 11
  { match: 53, date: "2026-05-10", home: "CSK",  away: "LSG",  time: ist("2026-05-10", 15, 30), homeGame: 11, awayGame: 11 },
  { match: 54, date: "2026-05-10", home: "RCB",  away: "MI",   time: ist("2026-05-10", 19, 30), homeGame: 11, awayGame: 11 },
  { match: 55, date: "2026-05-11", home: "PBKS", away: "DC",   time: ist("2026-05-11", 19, 30), homeGame: 11, awayGame: 12 },
  { match: 56, date: "2026-05-12", home: "GT",   away: "SRH",  time: ist("2026-05-12", 19, 30), homeGame: 12, awayGame: 12 },
  { match: 57, date: "2026-05-13", home: "RCB",  away: "KKR",  time: ist("2026-05-13", 19, 30), homeGame: 12, awayGame: 11 },
  { match: 58, date: "2026-05-14", home: "PBKS", away: "MI",   time: ist("2026-05-14", 19, 30), homeGame: 12, awayGame: 12 },
  { match: 59, date: "2026-05-15", home: "LSG",  away: "CSK",  time: ist("2026-05-15", 19, 30), homeGame: 12, awayGame: 12 },
  // Round 12
  { match: 60, date: "2026-05-16", home: "KKR",  away: "GT",   time: ist("2026-05-16", 19, 30), homeGame: 12, awayGame: 13 },
  { match: 61, date: "2026-05-17", home: "PBKS", away: "RCB",  time: ist("2026-05-17", 15, 30), homeGame: 13, awayGame: 13 },
  { match: 62, date: "2026-05-17", home: "DC",   away: "RR",   time: ist("2026-05-17", 19, 30), homeGame: 13, awayGame: 12 },
  { match: 63, date: "2026-05-18", home: "CSK",  away: "SRH",  time: ist("2026-05-18", 19, 30), homeGame: 13, awayGame: 13 },
  { match: 64, date: "2026-05-19", home: "RR",   away: "LSG",  time: ist("2026-05-19", 19, 30), homeGame: 13, awayGame: 13 },
  { match: 65, date: "2026-05-20", home: "KKR",  away: "MI",   time: ist("2026-05-20", 19, 30), homeGame: 13, awayGame: 13 },
  // Round 13
  { match: 66, date: "2026-05-21", home: "CSK",  away: "GT",   time: ist("2026-05-21", 19, 30), homeGame: 14, awayGame: 14 },
  { match: 67, date: "2026-05-22", home: "SRH",  away: "RCB",  time: ist("2026-05-22", 19, 30), homeGame: 14, awayGame: 14 },
  { match: 68, date: "2026-05-23", home: "LSG",  away: "PBKS", time: ist("2026-05-23", 19, 30), homeGame: 14, awayGame: 14 },
  // Round 14
  { match: 69, date: "2026-05-24", home: "MI",   away: "RR",   time: ist("2026-05-24", 15, 30), homeGame: 14, awayGame: 14 },
  { match: 70, date: "2026-05-24", home: "KKR",  away: "DC",   time: ist("2026-05-24", 19, 30), homeGame: 14, awayGame: 14 },
];

// 14 scoring weeks total: weeks 1–12 are the regular season, week 13 is semi-finals,
// week 14 is the final. Each week corresponds directly to a team's game number.
export const LEAGUE_WEEK_COUNT = 14;

// Each game round maps directly to the same fantasy week (1:1, no capping needed).
export function gameRoundToFantasyWeek(gameRound) {
  return gameRound;
}

const MONTHS = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
const fmtIST = (utcMs) => {
  // Shift to IST (UTC+5:30) then read as UTC date parts
  const d = new Date(utcMs + 5.5 * 3600 * 1000);
  return `${d.getUTCDate()} ${MONTHS[d.getUTCMonth()]}`;
};

function computeFantasyWeeks() {
  return Array.from({ length: LEAGUE_WEEK_COUNT }, (_, i) => {
    const n = i + 1;
    // Last week collects all remaining rounds (round 14 → week 14)
    const roundMatches = n < LEAGUE_WEEK_COUNT
      ? IPL_2026_MATCHES.filter(m => m.homeGame === n || m.awayGame === n)
      : IPL_2026_MATCHES.filter(m => m.homeGame >= n || m.awayGame >= n);
    const startTime = Math.min(...roundMatches.map(m => m.time));
    const endTime   = Math.max(...roundMatches.map(m => m.time));
    const s = fmtIST(startTime);
    const e = fmtIST(endTime);
    const label = s === e ? `Wk ${n} · ${s}` : `Wk ${n} · ${s} – ${e}`;
    return { week: n, startTime, label };
  });
}

export const FANTASY_WEEKS = computeFantasyWeeks();

// Get the current fantasy week based on real time.
// Returns the highest week whose first match has already started.
export function getCurrentFantasyWeek(now = Date.now()) {
  let current = 1;
  for (const w of FANTASY_WEEKS) {
    if (now >= w.startTime) current = w.week;
    else break;
  }
  return current;
}

// Get all IPL matches in a given fantasy week.
export function getMatchesForWeek(weekNum) {
  return IPL_2026_MATCHES.filter(m =>
    gameRoundToFantasyWeek(m.homeGame) === weekNum ||
    gameRoundToFantasyWeek(m.awayGame) === weekNum
  );
}

// Returns ms until the next week's first match (for countdown)
export function msUntilNextWeek(now = Date.now()) {
  const next = FANTASY_WEEKS.find(w => w.startTime > now);
  return next ? next.startTime - now : null;
}

export function weekLabel(weekNum) {
  return FANTASY_WEEKS.find(w => w.week === weekNum)?.label || `Week ${weekNum}`;
}
